import { Step } from 'react-joyride';

export const CREATE_REPORT_TOUR_KEY = 'create_report_v1';
export const CREATE_REPORT_TOUR_STORAGE_KEY = `tour_seen_${CREATE_REPORT_TOUR_KEY}`;

export const tourSteps: Step[] = [
    {
        target: '#tour-steps-sidebar, #tour-steps-sidebar-pill',
        content:
            'Navegue pelas seções do laudo aqui. Se o painel estiver oculto, use a pílula flutuante para abri-lo novamente.',
        title: 'Navegação',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '[data-preview-container]',
        content:
            'Este é o preview em tempo real do seu laudo. Ele mostra exatamente como ficará o documento final.',
        title: 'Visualização',
        placement: 'center',
    },
    {
        target: '#tour-tools-sidebar, #tour-tools-sidebar-pill',
        content:
            'Aqui você encontra as ferramentas e campos para preencher a seção atual. Se o painel estiver oculto, use a pílula flutuante para trazê-lo de volta.',
        title: 'Ferramentas e Edição',
        placement: 'left',
    },
    {
        target: '#tour-save-btn',
        content:
            'Salve seu progresso a qualquer momento. O sistema também salva automaticamente a cada minuto.',
        title: 'Salvar',
    },
    {
        target: '#tour-comments-btn',
        content:
            'Use os comentários para registrar observações, revisar pontos específicos do laudo e acompanhar tudo em um só lugar.',
        title: 'Comentários',
        placement: 'bottom',
    },
    {
        target: '#tour-customize-btn',
        content:
            'Personalize fontes, cores, cabeçalho e rodapé do seu laudo para deixá-lo com a sua cara.',
        title: 'Personalização',
    },
    {
        target: '#tour-save-template-btn',
        content:
            'Salve estruturas recorrentes como templates ou aplique modelos existentes para acelerar a criação de novos laudos.',
        title: 'Templates',
        placement: 'bottom',
    },
    {
        target: '#tour-export-btn',
        content:
            'Quando terminar, conclua o laudo e exporte o documento final para Word (DOCX), pronto para imprimir ou enviar.',
        title: 'Concluir e exportar',
    },
];
